<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="structure">
<div class="epigraph">
<p class="epf"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>“The meat defiant, the meat insurgent, the meat fighting, Sofia thought. The meat in full cry. . . .</p>
<p class="ep">Sitting by his head, she ran her hand along the fine soft fur of his cheek, over and over, while his body cooled and she paid the awful debt of love.”</p>
<p class="ept">Maria Doria Russell, <i>Children of God</i> (sequel to <i>The Sparrow</i>)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-King-0006.vue?d722c5b8